import { Options } from '@sheerid/jslib';
import { messagesEN } from './lib/intl/en-US';
import { RecursivePartial } from './lib/types/types';


export const programId = '633f45d7295c0551ab43b87a';

export const defaultOptions: RecursivePartial<Options> = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    logLevel: 'error',
    useFingerprinting: true,
    messagesWithLocale: {
        'en-US': messagesEN,
    },
    marketConsent: {
        enabled: false,
        required: false,
    },
};
